import type { IExtratoStatus } from '../../../../../hooks/useContaCilExtratos';

export const fmtValor = (v?: number | null) =>
  v == null
    ? '—'
    : v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtNumero = (n?: number | null) =>
  n == null ? '—' : new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(n);

export const fmtData = (iso?: string | null) => {
  if (!iso) return '—';
  const [a, m, d] = iso.split('T')[0].split('-');
  return `${d}/${m}/${a}`;
};

export const fmtPeriodo = (ini?: string | null, fim?: string | null) => {
  if (!ini && !fim) return '—';
  return `${fmtData(ini)} – ${fmtData(fim)}`;
};

export const fmtDataHora = (iso?: string | null) => {
  if (!iso) return '—';
  const dt = new Date(iso);
  if (Number.isNaN(dt.getTime())) return fmtData(iso);
  return dt.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Mapa de status -> colorScheme do Chakra + rótulo (mesmo do módulo).
export const STATUS_UI: Record<IExtratoStatus, { cor: string; label: string }> = {
  processando: { cor: 'blue', label: 'processando' },
  concluido: { cor: 'green', label: 'concluído' },
  erro: { cor: 'red', label: 'erro' },
  a_identificar: { cor: 'orange', label: 'a identificar' },
  aguardando_titular: { cor: 'orange', label: 'aguardando titular' },
  aguardando_validacao: { cor: 'yellow', label: 'aguardando validação' },
  quarentena: { cor: 'orange', label: 'quarentena' },
};

// Hex do accent por status (barra do card, borda do KPI ativo).
export const STATUS_ACCENT: Record<IExtratoStatus, string> = {
  processando: '#1B88F5',
  concluido: '#10B981',
  erro: '#EF4444',
  a_identificar: '#F59E0B',
  aguardando_titular: '#F59E0B',
  aguardando_validacao: '#F59E0B',
  quarentena: '#F97316',
};
